import { isBeekeeperSuperAdminAllowed } from '@lumapps/beekeeper/ducks/selectors';
import { isBeekeeperFeatureEnabled } from '@lumapps/features/ducks/selectors';
import { createSelector } from '@lumapps/redux/reselect';

export const isWorkflowsManagementEnabled = isBeekeeperFeatureEnabled('workflows_management');

export const isWorkflowsAllowed = createSelector(
    isBeekeeperSuperAdminAllowed,
    isWorkflowsManagementEnabled,
    (isAdminAllowed, isManagementEnabled) => isAdminAllowed && isManagementEnabled,
);
